import { AppPaths, RequestPaths } from '@ftr/routing-paths'
import { SideNavGroup } from './side-nav-item'

export const REQUEST_NAV_ITEMS_GROUP: SideNavGroup = {
  title: 'Request',
  items: [
    {
      type: 'LINK',
      icon: 'Recordings',
      title: 'Recordings',
      path: [AppPaths.Request, RequestPaths.Recordings, RequestPaths.ChooseCourt],
    },
    {
      type: 'LINK',
      icon: 'Transcript',
      title: 'Transcripts',
      path: [AppPaths.Request, RequestPaths.Transcripts, RequestPaths.ChooseCourt],
    },
  ],
}
